import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleOnClickLogout, getAllSignatures } from "../constants";
import {
  NavBar,
  SideBar,
  Breadcrumb,
  UnderConstruction,
  EmailSignatures,
} from "../components";

const EmailSignature = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [loading, setLoading] = useState(false);
  const [signatures, setSignatures] = useState([]);

  useEffect(() => {
    getAllSignatures(token, setSignatures);
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"email signatures"} />
        <div className="flex flex-col w-full bg-red-100">
          <Breadcrumb breads={["Emails"]} />
          <EmailSignatures signatures={signatures} />
        </div>
      </div>
    </div>
  );
};

export default EmailSignature;
